module.exports = __webpack_public_path__ + "static/media/font.d2d20859.png";